import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
import { MzGridListVisitComponent } from "../grid/mz-grid-list-visit/mz-grid-list-visit.component";
import { MzGridListVisitedComponent } from "../grid/mz-grid-list-visited/mz-grid-list-visited.component";
import { MzGridListVisitingComponent } from "../grid/mz-grid-list-visiting/mz-grid-list-visiting.component";

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent extends GridBaseCase {

  segmentVal:any = 0;
  @ViewChild("visit") visit: MzGridListVisitComponent;
  @ViewChild("visiting") visiting: MzGridListVisitingComponent;
  @ViewChild("visited") visited: MzGridListVisitedComponent;
  constructor() { super(); }

  ngOnInit() {
  }

  doRefresh($event){
    if(this.segmentVal == 0){
      this.visit.doRefresh($event);
    }else if(this.segmentVal == 1){
      this.visiting.doRefresh($event);
    }else if(this.segmentVal == 2){
      this.visited.doRefresh($event);
    }
  }

}
